export type LtiLmsNameMappings = Record<string, string>;

export interface LtiAppDataError {
	errors: any;
	lmsName: string;
	lmsNameMappings: LtiLmsNameMappings;
}

export enum ERROR_RENDERERS {
	ACTIVITY_NOT_FOUND = 'activity-not-found-error',
	INVALID_ACTIVITY_TYPE_CHANGE = 'invalid-activity-type-change-error',
	PARAMETER = 'parameter-error',
	TOOL_UNAVAILABLE = 'tool-unavailable-error',
	COURSE_LICENSE_EXPIRED = 'course-license-expired-error',
	MISSING_DEPLOYMENT = 'missing-deployment-error',
	DEFAULT = 'default-error',
	DEPRECATED_LAUNCH = 'deprecated-launch-error'
}
